import { capitalize } from "../../../app_shared_functions";

export const getTitle = ({ resource, type }) => {
  let val = `${capitalize(type)}: `;

  val += resource.name || resource.id || "Loading...";

  return val;
};
